// SCREENS.md global rule: a persistent "Reconnecting…" banner while offline, on every
// screen inside the shell (never blank, always honest about connectivity — §11.11).
export function ReconnectingBanner() {
  return (
    <p className="offline-banner" role="status">
      Reconnecting…
    </p>
  );
}
